import React, { useEffect, useState } from 'react';
import { getCharges, getPartenaires, getForages } from '../services/api';

const ChargesList: React.FC = () => {
  const [charges, setCharges] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [forages, setForages] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => {
    getPartenaires().then(r => setPartenaires(r.data));
    getForages().then(r => {
      const data = r.data.data || r.data;
      setForages(Array.isArray(data) ? data : []);
    });
  }, []);

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getCharges(params).then(r => {
      if (r.data.data) {
        setCharges(r.data.data);
        setTotal(r.data.total || 0);
        setTotalPages(r.data.totalPages || 1);
      } else {
        setCharges(Array.isArray(r.data) ? r.data : []);
        setTotal(Array.isArray(r.data) ? r.data.length : 0);
        setTotalPages(1);
      }
    }).catch(() => {});
  }, [page, filters]);

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Charges ({total.toLocaleString()})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => { setFilters({ ...filters, partenaire_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
        <select value={filters.forage_id || ''} onChange={e => { setFilters({ ...filters, forage_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les forages</option>
          {forages.map((f: any) => <option key={f.id} value={f.id}>{f.libelle}</option>)}
        </select>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Type de charge</th>
              <th>Libelle</th>
              <th>Forage</th>
              <th>Partenaire</th>
              <th>Quantite</th>
              <th>Montant (FCFA)</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {charges.map((c: any, i: number) => (
              <tr key={c.id || i}>
                <td><strong>{c.typecharge || '-'}</strong></td>
                <td>{c.libelle || '-'}</td>
                <td>{c.forage || '-'}</td>
                <td>{c.partenaire || '-'}</td>
                <td>{c.quantite || '-'}</td>
                <td>{c.montant?.toLocaleString()} FCFA</td>
                <td>{c.datecharge ? new Date(c.datecharge).toLocaleDateString('fr-FR') : '-'}</td>
              </tr>
            ))}
            {charges.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: '#999' }}>Aucune charge trouvee</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default ChargesList;
